module.exports = __webpack_public_path__ + "img/kbeauty-3.6e1bbd9a.svg";